// We only need to import the modules necessary for initial render
import CoreLayout from '../layouts/CoreLayout/CoreLayout'
import { storeNextRoute, logOutUser } from '../components/Auth'
import SearchRoute from './Search'
import SearchMemberRoute from './SearchMember'
import TeamListRoute from './TeamList'
import PracticeTemplateListRoute from './PracticeTemplateList'
import PracticeTemplateRoute from './PracticeTemplateNew'
import PracticeTemplateUpdateRoute from './PracticeTemplateUpdate'
import TeamRoute from './Team'
import TeamUpdateRoute from './TeamUpdate'
import TeamNewRoute from './TeamNew'
import ParticipantRoute from './Participant'
import ParticipantsRoute from './Participants'
import ParticipantNewRoute from './ParticipantNew'
import ParticipantUploadRoute from './ParticipantUpload'
import MembersRoute from './Members'
import MemberRoute from './Member'
import MemberNewRoute from './MemberNew'
import MemberUploadRoute from './MemberUpload'
import TemplateNewRoute from './TemplateNew'
import TemplateNewBundleRoute from './TemplateNewBundle'
import TemplateNewPrePurchaseRoute from './TemplateNewPrePurchase'
import TemplateRoute from './Template'
import TemplatesRoute from './Templates'
import LoginRoute from './Login'
import Login2FARoute from './Login2FA'
import MemberListRoute from './MemberList'
import ScreeningConfigRoute from './ScreeningConfig'
import TeamLicenseRoute from './TeamLicense'
import ExternalApiDebugRoute from './ExternalApiDebug'
import BillingCodesRoute from './BillingCodes'
import PatientFieldsRoute from './PatientFields'
import ReportConfig from './ReportConfig'
import ReferralProductsRoute from './ReferralProducts'
import RemindersRoute from './Reminders'
import InventoryReportsRoute from './InventoryReportsList'
import InventoryReportRoute from './InventoryReport'
import LicensesRoute from './Licenses'
import LicenseRoute from './License'
import LicenseNewRoute from './LicenseNew'
import SuperUser from './SuperUser'
import SuperUserCreate from './SuperUserCreate'
import SuperUserView from './SuperUserView'
import { checkCNOrigin } from 'constants/features'

const requireAuth = (store) => (nextState, replace) => {
  const state = store.getState()
  if (!(state.auth || {}).isAuthenticated) {
    store.dispatch(logOutUser())
  } else {
    const nextLocation = (state.router.locationBeforeTransitions || {}).pathname
    const nextRoute = nextLocation || '/'
    store.dispatch(storeNextRoute(nextRoute))
  }
  /* const token = localStorage.getItem('id_token')
  let storedRoute = state.auth && state.auth.nextRoute
  if(!(state.auth || {}).isAuthenticated) { // user is authenticated
    store.dispatch(logOutUser());
    if (token) {
      const tokenIsValid = await validateToken(token);
      if(tokenIsValid) { // set logged in state
        store.dispatch(setValidatedTokenLoggedInState(token));
        storedRoute = '/';
      }
      if (storedRoute) {
        replace(storedRoute);
        next(true);
      }
    }
  } else { // user is not authenticated
    const nextLocation = (state.router.locationBeforeTransitions || {}).pathname;
    const nextRoute = nextLocation || '/';
    store.dispatch(storeNextRoute(nextRoute));
  } */
}

const getLoginRoute = (store) => {
  if (checkCNOrigin()) {
    return Login2FARoute(store)
  }
  return LoginRoute(store)
}

export const createRoutes = (store) => ({
  path: '/',
  childRoutes: [
    {
      component: CoreLayout,
      onEnter: requireAuth(store),
      indexRoute: TeamListRoute(store),
      childRoutes: [
        PracticeTemplateListRoute(store),
        PracticeTemplateRoute(store),
        PracticeTemplateUpdateRoute(store),
        SearchRoute(store),
        SearchMemberRoute(store),
        TeamNewRoute(store),
        TeamRoute(store),
        ParticipantNewRoute(store),
        ParticipantUploadRoute(store),
        ParticipantRoute(store),
        ParticipantsRoute(store),
        MemberNewRoute(store),
        MemberUploadRoute(store),
        MembersRoute(store),
        MemberRoute(store),
        TeamUpdateRoute(store),
        TemplateNewRoute(store),
        TemplateNewBundleRoute(store),
        TemplateNewPrePurchaseRoute(store),
        TemplateRoute(store),
        TemplatesRoute(store),
        MemberListRoute(store),
        ScreeningConfigRoute(store),
        TeamLicenseRoute(store),
        ExternalApiDebugRoute(store),
        BillingCodesRoute(store),
        PatientFieldsRoute(store),
        ReportConfig(store),
        ReferralProductsRoute(store),
        RemindersRoute(store),
        InventoryReportsRoute(store),
        InventoryReportRoute(store),
        LicensesRoute(store),
        LicenseRoute(store),
        LicenseNewRoute(store),
        SuperUser(store),
        SuperUserCreate(store),
        SuperUserView(store)
      ]
    },
    {
      component: CoreLayout,
      childRoutes: [
        getLoginRoute(store)
      ]
    }
  ]
})

export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js